var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('forms-letter-selector-vue',{ref:"letterSelector",attrs:{"characters":_vm.filteredLetters,"preSelectedLetter":_vm.selectedLetter,"allow_click_on_empty_letter":true},on:{"update_letter":_vm.updateSelectedLetter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }